const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 12.681,
    height: 12.987,
    viewBox: "0 0 12.681 12.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_92",
    "data-name": "Vrstva 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_107",
    d: "M10.564 2.13A5.567 5.567 0 0 0 6.3 11.273l-2.659 2.651a.7.7 0 1 0 .988.988l2.679-2.7a5.5 5.5 0 0 0 3.243 1.051 5.567 5.567 0 0 0 0-11.133zm0 9.742A4.175 4.175 0 1 1 14.739 7.7a4.175 4.175 0 0 1-4.175 4.175z",
    "data-name": "Path 107",
    transform: "translate(-3.436 -2.13)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallSearch);
export default __webpack_public_path__ + "static/media/smallSearch.aa7a87e2c28d8c094ea8619f0fa39b9d.svg";
export { ForwardRef as ReactComponent };